import PropTypes from 'prop-types';
import classNames from 'classnames';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import { getDomainFromUrlIfDomainIsExternal } from '../../utils';
import ThemeContainer from '../../components/theme-container/ThemeContainer';
import { ContentTitle } from '../../components/typography/Heading';
import VisibleIf from '../../components/VisibleIf';
import List from '../../components/text/List';
import styles from './cms-list-with-illustration.module.less';
import Image from '../../components/image/Image';

const CMSListWithIllustration = ({
    title = '',
    list = [],
    illustrationUrl = '',
    illustrationTitle = '',
    linkUrl = '',
    linkTitle = '',
    symbol = {},
    ordered = false,
}) => {
    const trackingDomain = getDomainFromUrlIfDomainIsExternal(linkUrl);

    const checkmarkUrl = symbol?.fields?.file?.url;
    const hasImage = !!illustrationUrl;
    const hasSymbolImage = !!checkmarkUrl && !ordered;
    const listTagToUse = ordered ? 'ol' : 'ul';

    return (
        <ThemeContainer>
            <div className={classNames(styles.contentContainer, !hasImage && styles.contentContainerNoImage)}>
                <VisibleIf isVisible={!!illustrationUrl}>
                    <Image
                        className={styles.illustration}
                        src={illustrationUrl}
                        alt={illustrationTitle}
                        role="presentation"
                    />
                </VisibleIf>
                <div className={styles.content}>
                    <ContentTitle className={styles.title}>{title}</ContentTitle>
                    <List
                        className={`${styles.list} ${hasSymbolImage ? styles.customBulletList : ''}`}
                        tag={listTagToUse}
                    >
                        {list.map((text, index) => (
                            <li className={styles.listElement} key={index}>
                                <VisibleIf isVisible={hasSymbolImage}>
                                    <Image
                                        className={styles.listElementImage}
                                        src={checkmarkUrl}
                                        alt=""
                                        role="presentation"
                                    />
                                </VisibleIf>
                                <span className={styles.listElementText}>{text}</span>
                            </li>
                        ))}
                    </List>
                    {linkTitle && (
                        <TrackEventLink to={linkUrl} action={trackingDomain} category={'link'} className={styles.link}>
                            {linkTitle}
                        </TrackEventLink>
                    )}
                </div>
            </div>
        </ThemeContainer>
    );
};

CMSListWithIllustration.propTypes = {
    title: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    illustrationTitle: PropTypes.string,
    illustrationUrl: PropTypes.string,
    linkUrl: PropTypes.string,
    linkTitle: PropTypes.string,
};

export default CMSListWithIllustration;
